import { Skeleton } from 'antd';
import { FC } from 'react';

import useSWRProductInventory from 'src/hooks/swr/useSWRProductInventory';

interface InventoryNameProps {
  inventoryId: string;
  className?: string;
}

const InventoryName: FC<InventoryNameProps> = ({ inventoryId, className }) => {
  const { inventory, isLoading, error } = useSWRProductInventory(inventoryId);

  if (isLoading) {
    return <Skeleton.Input active size='small' style={{ width: 120 }} />;
  }

  if (error || !inventory) {
    return <span>오류 발생</span>;
  }

  return <span className={className}>{inventory.inventoryName}</span>;
};

export default InventoryName;
